import PrivacyControl from "./PrivacyControl";
import privacyControlRehydrator from "./PrivacyControl.rehydrator";

export default PrivacyControl;
export { privacyControlRehydrator };
